<template>
  <v-app>
    <v-main>
      <v-container fluid class="pt-0">
        <router-view />
      </v-container>
    </v-main>
    <v-snackbar bottom right :timeout="60" :value="updateExists">
      <v-layout class="justify-space-between align-center">
        <span>An update is available</span>
        <v-btn @click="refreshApp" color="primary">
          refresh
        </v-btn>
      </v-layout>
    </v-snackbar>
  </v-app>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import BrokerService from '@/services/broker'
import PublicSettingService from '@/services/publicSetting'

export default {
  name: 'App',
  data() {
    return {
      broker: {},
      whiteBrandingSetting: null,
      refreshing: false,
      registration: null,
      updateExists: false
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('setting', ['whiteBranding'])
  },
  created: async function() {
    /* PWA */
    // Listen for our custom event from the SW registration
    document.addEventListener('swUpdated', this.updateAvailable, { once: true })

    // Prevent multiple refreshes
    navigator.serviceWorker?.addEventListener('controllerchange', () => {
      if (this.refreshing) return
      this.refreshing = true

      // Here the actual reload of the page occurs
      window.location.reload()
    })

    await this.getPublicSettings()
    this.handleWhiteBranding()
    const searchParams = new URLSearchParams(window.location.search)
    const params = Object.fromEntries(searchParams.entries())
    const broker = params.broker

    if (broker && this.whiteBranding) {
      await this.getBrokerInfo(broker)
      if (this.broker.id) {
        this.$vuetify.theme.themes.light.primary = this.broker.color
      }
    }
  },
  methods: {
    ...mapActions('setting', ['setWhiteBranding']),
    async getBrokerInfo(code) {
      this.isLoading = true
      try {
        const { data } = await BrokerService.getBrokerInfo(code)
        this.broker = data
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false
      }
    },

    async getPublicSettings() {
      const { data } = await PublicSettingService.fetch({})
      this.whiteBrandingSetting = data.find(
        item => item.key == 'white_branding'
      )?.value
      this.setWhiteBranding(this.whiteBrandingSetting)
    },

    handleWhiteBranding() {
      if (this.user?.broker && this.whiteBranding) {
        this.$vuetify.theme.themes.light.primary = this.user.broker.color
      }
    },

    updateAvailable(event) {
      this.registration = event.detail
      this.refreshApp()
    },

    // Called when the user accepts the update
    refreshApp() {
      this.updateExists = false
      // Make sure we only send a 'skip waiting' message if the SW is waiting
      if (!this.registration || !this.registration.waiting) return
      this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
    }
  }
}
</script>
<style>
.theme--light.v-application {
  /*background: #fbfbfb;*/
  background: white;
  font-family: 'Libre Franklin', sans-serif;
}

.v-tabs-bar {
  border-bottom: 1px solid #e0e0e0;
}

.v-application--wrap {
  min-height: 100% !important;
}

.v-main {
  min-height: 100vh;
}

.menu-content {
  max-height: 100% !important;
}

input:-webkit-autofill,
textarea:-webkit-autofill,
select:-webkit-autofill {
  /* background-color: #555b00 !important; */
  /* color: #e8e6e3 !important; */
  color: #e8e6e3;
}

::-webkit-scrollbar {
  width: 7.5px;
  height: 7.5px;
}
::-webkit-scrollbar {
  background-color: white;
  color: #aba499;
}
::-webkit-scrollbar-thumb {
  background-color: #d8d8d8;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #d8d8d8;
}
::-webkit-scrollbar-thumb:active {
  background-color: #d8d8d8;
}
::-webkit-scrollbar-corner {
  background-color: #d8d8d8;
}

::-webkit-scrollbar-track {
  border-radius: 10px;
}

body {
  scrollbar-color: #1e3e52 white;
}

html {
  scrollbar-color: #1e3e52 white;
}

.v-menu__content.theme--light.menuable__content__active.v-autocomplete__content {
  border-radius: 10px;
}
</style>
<style lang="sass">
.v-snack__wrapper
  .v-snack__content
    font-weight: 600
    font-size: 1.12rem
    color: white

  &.error
    .v-snack__content
      color: white

.v-alert__wrapper
  .v-alert__content
    font-weight: 600

.v-alert
  &.error
    .v-alert__wrapper
      .v-alert__content
        color: white

.theme--light
  .v-input:not(.account-select) input, .theme--light.v-input textarea
    color: var(--v-primary-base) !important
  .v-label
    color: var(--v-primary-base) !important
</style>
